import { Star, X } from 'lucide-react';
import { HarryIcon } from './HarryIcon';
import { useTheme } from '../../contexts/ThemeContext';

export function HarryIsmCard({
  ism,
  error,
  spinning,
  onDismiss,
  onSave,
  saved = false,
  compact = false,
}: {
  ism: string | null;
  error: string | null;
  spinning: boolean;
  onDismiss?: () => void;
  onSave?: () => void;
  saved?: boolean;
  compact?: boolean;
}) {
  const { isDark } = useTheme();
  if (!ism && !error && !spinning) return null;

  return (
    <div
      className={` border ${
        compact ? 'p-2.5' : 'p-3'
      } ${
        isDark ? 'border-[var(--rule-bright)] bg-[var(--bg-raised)]' : 'border-[var(--mustard)] bg-[var(--mustard-dim)]/50'
      }`}
    >
      <div className="flex items-start gap-2">
        <HarryIcon size={compact ? 18 : 22} />
        <div className="min-w-0 flex-1">
          <p className={`text-[10px] font-semibold uppercase tracking-wide ${
            isDark ? 'text-[var(--text-ter)]' : 'text-[var(--mustard)]/80'
          }`}>
            Harry-ism
          </p>
          {spinning && (
            <p className={`mt-0.5 text-sm ${isDark ? 'text-[var(--text-sec)]' : 'text-[var(--text-sec)]'}`}>
              Spinning…
            </p>
          )}
          {error && !spinning && (
            <p className={`mt-0.5 text-xs ${isDark ? 'text-[var(--coral)]' : 'text-[var(--mustard)]'}`}>
              {error}
            </p>
          )}
          {ism && !spinning && (
            <p className={`mt-0.5 text-sm italic leading-relaxed ${
              isDark ? 'text-[var(--text-pri)]' : 'text-[var(--text-pri)]'
            }`}>
              “{ism}”
            </p>
          )}
        </div>
        <div className="flex flex-shrink-0 items-center gap-0.5">
          {onSave && ism && !spinning && (
            <button
              type="button"
              onClick={onSave}
              className={`rounded p-0.5 transition-colors ${
                saved
                  ? 'text-[var(--mustard)]'
                  : isDark
                    ? 'text-[var(--text-ter)] hover:text-[var(--mustard)]'
                    : 'text-[var(--text-ter)] hover:text-[var(--mustard)]'
              }`}
              title={saved ? 'Remove from favorites' : 'Save Harry-ism'}
              aria-label={saved ? 'Remove from favorites' : 'Save Harry-ism'}
            >
              <Star className={`h-3.5 w-3.5 ${saved ? 'fill-current' : ''}`} />
            </button>
          )}
          {onDismiss && (ism || error) && !spinning && (
            <button
              type="button"
              onClick={onDismiss}
              className={`rounded p-0.5 ${
                isDark
                  ? 'text-[var(--text-ter)] hover:bg-[var(--hover-tint)]'
                  : 'text-[var(--text-ter)] hover:bg-[var(--bg-raised)]/80'
              }`}
              aria-label="Dismiss"
            >
              <X className="h-3 w-3" />
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
